
import j2 from './journalize/j2.png'
import j3 from './journalize/j3.png'
import j4 from './journalize/j4.png'
import j5 from './journalize/j5.png'
import j6 from './journalize/j6.png'
import j7 from './journalize/j7.png'
import j8 from './journalize/j8.png'
import j9 from './journalize/j9.png'
import j10 from './journalize/j10.png'


import sg2 from './scan&go/sg2.png'
import sg3 from './scan&go/sg3.png'
import sg4 from './scan&go/sg4.png'
import sg5 from './scan&go/sg5.png'
import sg6 from './scan&go/sg6.png'
import sg7 from './scan&go/sg7.png'
import sg8 from './scan&go/sg8.png'

import mario from './pixelArt/Mario.png'
import pokeball from './pixelArt/Pokeball.png'
import megaman from './pixelArt/Megaman.png'



export const imgDir = {
    projects: {
        journalize: [
            j2,
            j3,
            j4,
            j5,
            j6,
            j7,
            j8,
            j9,
            j10
        ],
        scango: [
            sg2,
            sg3,
            sg4,
            sg5,
            sg6,
            sg7,
            sg8
        ],
        pixelArt: [
            mario,
            pokeball,
            megaman
        ]
    }
};